import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {MarkdownModule} from 'ngx-markdown';
import {HttpClientModule, HttpClient} from '@angular/common/http';
import {MatDialogModule} from '@angular/material';
import {MatDatepickerModule, MatNativeDateModule, MatFormFieldModule, MatInputModule} from '@angular/material';

import {APP_BASE_HREF} from '@angular/common';

import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';

import {RecaptchaModule} from 'ng-recaptcha';

import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {StellenangeboteComponent} from './stellenangebote/stellenangebote.component';
import {BewerbungComponent} from './bewerbung/bewerbung.component';
import {StellenbeschreibungComponent} from './stellenbeschreibung/stellenbeschreibung.component';
import {PopupComponent, MenuComponent} from './menu/menu.component';
import {StellenangeboteFilterPipe} from './stellenangebote/stellenangebote-filter.pipe';

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
}

@NgModule({
    declarations: [
        AppComponent,
        StellenangeboteComponent,
        BewerbungComponent,
        StellenbeschreibungComponent,
        MenuComponent,
        StellenangeboteFilterPipe,
        PopupComponent
    ],
    imports: [
        MarkdownModule.forRoot(),
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        FormsModule,
        MatDialogModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatFormFieldModule,
        MatInputModule,
        HttpClientModule,
        RecaptchaModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        })
    ],
    entryComponents: [MenuComponent, PopupComponent],
    providers: [{provide: APP_BASE_HREF, useValue: '/'}],
    bootstrap: [AppComponent]
})
export class AppModule {
}
